import { Card, CardActions, CardContent, CardHeader, CardMedia, Chip, FormControlLabel, Grid, IconButton, Menu, MenuItem, Switch, Tooltip, Typography } from "@mui/material";
import { IProduto } from "../../interfaces/IProduto";
import { useLetras } from "../../../core/hooks/useLetras";
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import { useMoeda } from "../../../core/hooks/useMoeda";
import { useNavigate } from "react-router-dom";
import { ICategoria } from "../../interfaces/ICategoria";
import { useState } from "react";
import { CopiarProdutoModal } from "../CopiarProdutoModal";
import MoreVertIcon from '@mui/icons-material/MoreVert';
import CopyAllIcon from '@mui/icons-material/CopyAll';
import { ConfirmacaoAcaoModal } from "../../../core/components/ConfirmacaoAcaoModal";
import { useProdutos } from "../../hooks/useProdutos";

interface CardPesoCardapioProps {
    produto: IProduto;
    excluir: (produto: IProduto) => void;
    categoriaUuid: string;
    categorias: ICategoria[];
    handleRefresh: () => void;
}

export const CardPesoCardapio = ({
    excluir,
    produto,
    categoriaUuid,
    categorias,
    handleRefresh
}: CardPesoCardapioProps) => {
    const navigate = useNavigate();
    const { maiusculas } = useLetras();
    const { real } = useMoeda();

    const [copiarProduto, setCopiarProduto] = useState<boolean>(false);
    const handleAbrirCopiarProduto = () => setCopiarProduto(true);
    const handleFecharCopiarProduto = () => setCopiarProduto(false);

    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);
    const handleClick = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };

    const [openAtivar, setOpenAtivar] = useState(false);
    const handleOpenAtivar = () => setOpenAtivar(true);
    const handleCloseAtivar = () => setOpenAtivar(false);
    const { salvar, loading } = useProdutos();

    const ativar = async () => {
        await salvar(categoriaUuid, { ...produto, inativadoAs: undefined });
        handleRefresh();
    };

    const inativar = async () => {
        await salvar(categoriaUuid, { ...produto, inativadoAs: new Date() });
        handleRefresh();
    };

    const configuracaoPeso = produto.configuracaoPeso ?? produto.configuracao;

    return (
        <>
            <CopiarProdutoModal handleRefresh={handleRefresh} categorias={categorias} open={copiarProduto} produto={produto} handleCancelar={handleFecharCopiarProduto} />
            <ConfirmacaoAcaoModal
                titulo={produto?.inativadoAs == undefined ? "Inativar produto" : "Ativar produto"}
                descricao={produto?.inativadoAs == undefined
                    ? "Nenhum marketplace pode visualizar um produto quando ele está inativo."
                    : "O produto estará disponível nos marketplaces configurados."
                }
                open={openAtivar}
                onCancelar={handleCloseAtivar}
                onConfirmar={produto?.inativadoAs == undefined ? inativar : ativar}
                loading={loading}
            />
            <Grid item xs={12} md={4} xl={3}>
                <Card variant="outlined">
                    <CardHeader
                        title={
                            <Tooltip title={maiusculas(produto.descricao)}>
                                <Typography variant="h6">{maiusculas(produto.descricao, 20)}</Typography>
                            </Tooltip>
                        }
                        action={
                            <>
                                <IconButton aria-label="settings" onClick={handleClick}>
                                    <MoreVertIcon />
                                </IconButton>
                                <Menu anchorEl={anchorEl} open={open} onClose={handleClose}>
                                    <MenuItem onClick={() => navigate(`/cardapio/categorias/${categoriaUuid}/produtos/${produto.uuid}`)}>
                                        <EditIcon fontSize="small" sx={{ marginRight: "10px" }} /> Editar
                                    </MenuItem>
                                    <MenuItem onClick={() => excluir(produto)}>
                                        <DeleteIcon fontSize="small" sx={{ marginRight: "10px" }} /> Excluir
                                    </MenuItem>
                                    <MenuItem onClick={handleAbrirCopiarProduto}>
                                        <CopyAllIcon fontSize="small" sx={{ marginRight: "10px" }} /> Copiar
                                    </MenuItem>
                                </Menu>
                            </>
                        }
                        sx={{ height: "90px" }}
                        subheader={
                            <FormControlLabel
                                control={<Switch checked={produto?.inativadoAs == undefined} size='small' />}
                                label={produto?.inativadoAs == undefined ? "Ativo" : "Inativo"}
                                onClick={handleOpenAtivar}
                            />
                        }
                    />
                    {produto.imagens?.length ? (
                        <CardMedia
                            component="img"
                            height="140"
                            image={`${produto.imagens[0].url}`}
                            sx={{ objectFit: "cover" }}
                            alt="Por peso"
                        />
                    ) : (
                        <CardMedia
                            component="img"
                            height="140"
                            image={`${process.env.PUBLIC_URL}/images/produtos/preparado.png`}
                            sx={{ objectFit: "contain" }}
                            alt="Por peso"
                        />
                    )}
                    <CardContent sx={{ height: "180px" }}>
                        {configuracaoPeso?.precoPorKg && (
                            <Chip sx={{ margin: "0.3rem" }} label={`${real(configuracaoPeso.precoPorKg)} / kg`} />
                        )}
                        {configuracaoPeso?.valorTeto && (
                            <Chip sx={{ margin: "0.3rem" }} color="success" label={`Teto: ${real(configuracaoPeso.valorTeto)}`} />
                        )}
                    </CardContent>
                </Card>
            </Grid>
        </>
    );
};
